'use strict'

import { apiInstance, legacyV2 } from './index'
import { mapArgs } from 'utils/functions'

const financial = {
  getInvoiceById (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/refund/breakdown`,
      timeout: 45000,
      params
    })
  },

  importValuesInBulk (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/refunds/discount/csv`,
      headers: { 'Content-Type': 'multipart/form-data' },
      data
    })
  },

  setTotalvalue (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/refunds/discount`,
      data
    })
  },

  getInvoicesHistory (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/refunds`,
      params
    })
  },

  getRidesBillets (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/refund/report`,
      params
    })
  },

  getServiceBillets (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/service/report`,
      params
    })
  },

  getReceipts (invoiceId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/refund/${invoiceId}/receipts`,
      params
    })
  },

  getFinancialReceipts (invoiceId, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/refund/${invoiceId}/receipts`,
      params
    })
  },

  getCreditCard (companyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company/${companyId}/creditcard`
    })
  },

  getPaymentMethod (companyId) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV2()}/company/${companyId}/financialConfig`
    })
  },

  setPaymentMethod (...args) {
    const data = mapArgs(...args)
    return apiInstance({
      method: 'POST',
      url: `${legacyV2()}/change/paymentMethod`,
      data
    })
  }
}

export default financial
